var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("args")))]),
      _vm.isReady
        ? _c(
            "w-card-content",
            [
              _vm.askedTitlesCount > 0
                ? _c("app-asked-titles-input", {
                    attrs: { settings: _vm.settings.Settings },
                  })
                : _vm._e(),
              _vm.isBookkeepingReport
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("recreate-bookkeeping") },
                            model: {
                              value: _vm.recreateBookkeeping,
                              callback: function ($$v) {
                                _vm.recreateBookkeeping = $$v
                              },
                              expression: "recreateBookkeeping",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.settings.Settings.isBookYearFilterRequired()
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-multi-select-book-year", {
                            attrs: { fancy: "", label: _vm.$ct("bookyears") },
                            model: {
                              value: _vm.selectedBookYears,
                              callback: function ($$v) {
                                _vm.selectedBookYears = $$v
                              },
                              expression: "selectedBookYears",
                            },
                          }),
                          _c("w-checkbox", {
                            attrs: {
                              value: _vm.useAllBookYears,
                              label: _vm.$ct("use-all-bookyears"),
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setUseAllBookYears($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.script
                ? _vm._l(_vm.script.ExtraArgs, function (arg, i) {
                    return _c("app-script-arg-input", {
                      key: `extra-arg-${i}`,
                      attrs: { arg: arg },
                      model: {
                        value: _vm.scriptValues[i],
                        callback: function ($$v) {
                          _vm.$set(_vm.scriptValues, i, $$v)
                        },
                        expression: "scriptValues[i]",
                      },
                    })
                  })
                : _vm._e(),
              _vm.model
                ? _vm._l(
                    _vm.settings.Settings.AskedFilters,
                    function (filter, i) {
                      return _c("app-report-asked-filter-input", {
                        key: `asked-filter-${i}`,
                        attrs: {
                          model: _vm.model,
                          filter: filter,
                          settings: _vm.settings,
                        },
                      })
                    }
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.confirmDisabled, icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }